import React from "react";
import { FaFutbol, FaMusic, FaShareAlt } from "react-icons/fa";
import "./Interests.css";

const Interests = () => (
  <section className="interests-section">
    <h2>🌟 Centres d'intérêt</h2>
    <ul className="interests-list">
      <li>
        <FaFutbol className="interest-icon" />
        <span>
          Sport & loisirs : football, activités de plein air, détente en famille
        </span>
      </li>
      <li>
        <FaMusic className="interest-icon" />
        <span>Musique : écoute, découverte de nouveaux genres, partage</span>
      </li>
      <li>
        <FaShareAlt className="interest-icon" />
        <span>
          Réseaux sociaux : veille technologique, partage de connaissances,
          networking
        </span>
      </li>
    </ul>
    <div className="interests-note">
      <span role="img" aria-label="smile">
        😊
      </span>
      Curieux, ouvert d’esprit et passionné, j’aime apprendre et partager, aussi
      bien dans le cadre professionnel que personnel.
    </div>
  </section>
);

export default Interests;
